import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const SmsConsentNoteWrapper = styled(Box)(
  ({ theme }) => `
    width: 100%;
    margin: 0 0 ${theme.spacing(7)};

    p,
    a {
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      color: ${theme.palette.gray[600]};
      margin: 0;
    }

    a {
      text-decoration: underline;
    }

    label {
      cursor: pointer;
    }
`
);
